import moment from 'moment'
import gql from 'graphql-tag'
import client from '@stores/apollo'
import { EmployeeDetailsFragment } from '@api/fragments'
import { IEmployeeDetails } from '@api/types'

interface Payload {
  data: {
    employee: IEmployeeDetails
  }
}

export default function details(id: string, assignmentPlanId?: string): Promise<IEmployeeDetails> {
  return client.gql
    .query({ query, variables: { id, assignmentPlanId } })
    .then(({ data: { employee } }: Payload) => ({
      ...employee,
      startDate: employee.startDate ? moment(employee.startDate).toDate() : null,
      endDate: employee.endDate ? moment(employee.endDate).toDate() : null,
    }))
}

const query = gql`
  query EmployeeDetails($id: ID!, $assignmentPlanId: ID) {
    employee: node(id: $id) {
      ...EmployeeDetailsFragment
    }
  }
  ${EmployeeDetailsFragment}
`
